import React from "react";

interface LocalBusinessSchemaProps {
    siteName: string;
    logoUrl: string;
    url: string;
    address: {
        street: string;
        postalCode: string;
        city: string;
        country: string;
    };
    telephone?: string;
    openingHours?: {
        weekDays: string[];
        specialDays?: string[];
    };
}

const LocalBusinessSchema: React.FC<LocalBusinessSchemaProps> = ({ siteName, logoUrl, url, address, telephone, openingHours }) => {
    const weekHours = openingHours?.weekDays?.map((dayString) => {
        const parts = dayString.split(" ");
        const dayName = parts[0];
        const times = parts.slice(1).join(" ").split("-");
        return {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": dayName,
            "opens": times[0]?.trim().replace(".", ":"),
            "closes": times[1]?.trim().replace(".", ":"),
        };
    });

    const specialHours = openingHours?.specialDays?.map((dayString) => {
        // Example: "2025-12-24 16.00 - 22.00"
        const [date, timeRange] = dayString.split(" ");
        const times = timeRange.split("-");
        return {
            "@type": "OpeningHoursSpecification",
            "validFrom": date,
            "validThrough": date,
            "opens": times[0]?.trim().replace(".", ":"),
            "closes": times[1]?.trim().replace(".", ":"),
        };
    });

    const schema = {
        "@context": "https://schema.org",
        "@type": "BarOrPub",
        "name": siteName,
        "image": logoUrl,
        "address": {
            "@type": "PostalAddress",
            "streetAddress": address.street,
            "postalCode": address.postalCode,
            "addressLocality": address.city,
            "addressCountry": address.country,
        },
        "telephone": telephone,
        "url": url,
        "openingHoursSpecification": [...(weekHours || []), ...(specialHours || [])],
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
    );
};

export default LocalBusinessSchema;
